import React from 'react';
import PropTypes from 'prop-types';

const renderImages = (images) => {
  if (!images) {
    return null;
  }

  return images.map(image => {
    const alt = image.charAt(1).toUpperCase() + image.slice(2, image.indexOf('.png')) + ' chart';
    return <img src={image} alt={alt} key={image} className="mr3 mb4-l mb3" width={100}/>

  });
};

const Metric = ({ name, images, link }) => {
  return (

    <a href={link} target="_blank"  className="no-underline dib w-40-l w-100 grow-custom cf tl pa4-ns pv3 ph4 result ma3-l mh0 mv2 br4 self-start">

      <div>


      {renderImages(images)}


      <h2 className="dark-blue-gray f3-ns f4 fw4 mt0 mb3 lh-title">{name}</h2>

      <p className="gecko-green f5 mb0">Learn more</p>




      </div>
    </a>
  );
};

Metric.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  link: PropTypes.string,
  images: PropTypes.array,
};

export default Metric;



// WEBPACK FOOTER //
// ./src/components/metric/Metric.js